export const TABLE_VERSION_REQUEST = 'TABLE_VERSION_REQUEST';
export const TABLE_VERSION_SUCCESS = 'TABLE_VERSION_SUCCESS';
export const TABLE_VERSION_FAILURE = 'TABLE_VERSION_FAILURE';